import { render, staticRenderFns } from "./MyprofileEdit.vue?vue&type=template&id=ca68c58a&scoped=true"
import script from "./MyprofileEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyprofileEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyprofileEdit.vue?vue&type=style&index=0&id=ca68c58a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca68c58a",
  null
  
)

export default component.exports